import { isDigitEmbed } from './index';
import { DIGIT_EMBED } from '../const';

/**
 * 占位符校验：
 * 1. 数量一致
 * 2. id一一对应
 * 3. 域成对存在
 * 4. 域开闭顺序（同一对，开始标记必须在结束标记之前）
 * 5. 域交叉（交叉批不允许保存和提交）
 */
// 获取占位符元素的ID
const getDigitInfo = (deltaItem) => {
  let info = {};
  if (!deltaItem.attributes) return {};

  const embedLabels = Object.values(DIGIT_EMBED);
  embedLabels.forEach((item) => {
    if (deltaItem.attributes[item]) {
      info = deltaItem.attributes[item];
    }
  });
  return info;
};

// 占位符校验
export const digitsCheck = (srcList, peList) => {
  const srcDigits = srcList.filter((item) => isDigitEmbed(item));
  const peDigits = peList.filter((item) => isDigitEmbed(item));

  // 1. 数量一致
  if (srcDigits.length !== peDigits.length) {
    return {
      hasError: true,
      msg: '占位符数量不一致',
    };
  }

  // 2. id一一对应
  // peDigits中剔除srcDigits中存在的元素，剔除完不为空，则匹配有误
  const peDigitsCopy = [...peDigits];
  srcDigits.forEach((srcItem) => {
    const srcId = getDigitInfo(srcItem)?.id;
    const matchIndex = peDigitsCopy.findIndex(
      (peItem) => getDigitInfo(peItem)?.id === srcId,
    );
    if (matchIndex > -1) {
      peDigitsCopy.splice(matchIndex, 1);
    }
  });
  if (peDigitsCopy.length !== 0) {
    return {
      hasError: true,
      msg: '占位符id对应有误',
    };
  }

  // 3. 域匹配校验
  const isMatched = fieldsCheck(peList);

  if (!isMatched) {
    return {
      hasError: true,
      msg: '域标签匹配有误',
    };
  }

  return {
    hasError: false,
    msg: '',
  };
};

// 域匹配校验：参考括号的校验规则
export const fieldsCheck = (list) => {
  const fields = list?.filter((item) => item?.attributes?.[DIGIT_EMBED.field]);
  const stack = [];
  for (let i = 0; i < fields.length; i++) {
    const item = fields[i];

    // 经过了quill中对arrts的转换，所以这里的isOpen和isClose是字符串
    if (getDigitInfo(item)?.isOpen === 'true') {
      stack.push(item);
    }

    if (getDigitInfo(item)?.isClose === 'true') {
      const top = stack.pop();
      // 结束符应和栈顶元素匹配
      if (!top || getDigitInfo(top)?.id !== getDigitInfo(item)?.id) {
        return false;
      }
    }
  }

  return !stack.length;
};
